module.exports = __webpack_public_path__ + "statics/img/drf_l.png";